import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';

import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

import { NavbarComponent } from '../navbar/navbar.component';
import { FooterComponent } from '../footer/footer.component';
import { RegistrationValidator } from '../shared/validators/register.validator';

import { AuthService } from '../core/services/auth.service';

@Component({
    selector: 'app-reset-password',
    standalone: true,
    imports: [
        NavbarComponent,
        FooterComponent,
        TranslocoPipe,
        RouterModule,
        CommonModule,
        ReactiveFormsModule
    ],
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
    private readonly subscription: Subscription = new Subscription();

    resetPasswordForm: UntypedFormGroup;
    token: string;
    loading: boolean;
    error: boolean;
    verificationMessage: boolean = false;

    constructor(private fb: UntypedFormBuilder,
        private authService: AuthService,
        public translate: TranslocoService,
        private route: ActivatedRoute,
        private router: Router) {
        this.resetPasswordForm = fb.group({
            pwd: ["", [Validators.required, Validators.minLength(8)]],
            confirmPwd: ["", Validators.required]
        }, {
            validator: RegistrationValidator('pwd', 'confirmPwd')
        });
    }

    get resetPasswordControls() {
        return this.resetPasswordForm.controls;
    }

    ngOnInit() {
        this.subscription.add(this.route.params.subscribe(params => {
            if (!params['token'] || params['token'] == null) this.router.navigate([this.translate.getActiveLang(), 'password', 'forgot'], { queryParams: { source: 'resetPassword' } });
            this.authService.checkResetToken(params['token'])
                .pipe(first())
                .subscribe(
                    _ => {
                        this.token = params['token'];
                    },
                    _ => {
                        this.router.navigate([this.translate.getActiveLang(), 'password', 'forgot'], { queryParams: { source: 'resetPassword' } });
                    });
        }
        )
        );
    }

    onSubmit(password: string) {
        this.loading = true;
        if (this.resetPasswordForm.invalid) {
            this.loading = false;
            return;
        } else {
            this.error = false;
            this.authService.resetPassword(password, this.token)
                .pipe(first())
                .subscribe(
                    _ => {
                        this.loading = false;
                        this.verificationMessage = true;
                    },
                    _ => {
                        this.error = true;
                    }
                );
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe()
    }
}
